import { Component } from '@angular/core';

@Component({
  selector: 'fs-appliance-dashboard-warning-banner',
  templateUrl: './appliance-dashboard-warning-banner.component.html',
  styleUrls: ['./appliance-dashboard-warning-banner.component.scss'],
})
export class ApplianceDashboardWarningBannerComponent {}
